'use client';

import React, { useEffect, useState } from 'react';
import FormFooter from '../FormFooter/FormFooter';
import FormHeader from '../FormHeader/OfferWallHeader';
import checkmark from '@/assets/animations/checkmarkAnim.json';
import animation from '@/assets/animations/loadingAnim.json';
import styles from './Loading.module.scss';
import AnimationContainer from '../Animation/AnimationContainer';
import { withOwnLinkToken } from '@/utils/withOwnLinkToken';

interface Props {
  loading: boolean;
  redirectValue: string;
}

const EngineLoading = ({ loading, redirectValue }: Props) => {
  const [currentVideo, setCurrentVideo] = useState<'first' | 'second' | null>(
    null
  );
  const [isVisible, setIsVisible] = useState(loading);

  const handleSecondVideoEnd = () => {
    withOwnLinkToken(redirectValue).then((url) => window.location.replace(url));
  };

  const handleFirstVideoEnd = () => {
    setCurrentVideo('second');
  };

  useEffect(() => {
    if (loading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsVisible(true);
      setCurrentVideo('first');
    }
  }, [loading]);

  return (
    <div
      className={`${styles.wrapper} ${styles.submissionLoader} ${isVisible ? styles.visibleGreeting : ''}`}
    >
      <FormHeader hiddenText hiddenAdDisclosure />
      <div className={styles.loaderWrapper}>
        <div className={styles.wrapper}>
          <div className={styles.animationWrapper}>
            {currentVideo === 'first' && (
              <AnimationContainer
                animation={animation}
                isActive={currentVideo === 'first'}
                play={currentVideo === 'first'}
                loop={loading}
                onComplete={handleFirstVideoEnd}
              />
            )}
            {currentVideo === 'second' && (
              <AnimationContainer
                animation={checkmark}
                isActive={currentVideo === 'second'}
                play={currentVideo === 'second'}
                loop={false}
                onComplete={handleSecondVideoEnd}
              />
            )}
          </div>
          <h3 className={`${styles.title} ${styles.engineTitle}`}>
            One moment while we update
            <br />
            your profile
          </h3>

          <p className={styles.text}>The process may take up to 10 seconds</p>
        </div>
      </div>
      <div className={styles.container}>
        <FormFooter variant="offer-wall" />
      </div>
    </div>
  );
};

export default EngineLoading;
